import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Work } from './components/Work';
import { Reels } from './components/Reels';
import { Gallery } from './components/Gallery';
import { Philosophy } from './components/Philosophy';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import GalleryPage from './pages/GalleryPage';

// Home page component
const HomePage: React.FC = () => (
  <>
    <Header />
    <main className="flex-grow">
      <Hero />
      <Work />
      <Reels />
      <Gallery />
      <Philosophy />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col font-sans selection:bg-stone-200 selection:text-stone-900">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;